<div class="manage-tables-container">
  <!-- Table List View -->
  <div *ngIf="!showTableEditor" class="table-list-view">
    <div class="header">
      <h2>Manage Tables</h2>
      <p>Create, edit, and manage your custom table configurations</p>
      <button mat-raised-button color="primary" (click)="onCreateTable()" class="create-button">
        <mat-icon>add</mat-icon>
        Create Table
      </button>
    </div>

    <div class="content">
      <!-- Loading spinner -->
      <div *ngIf="loading" class="loading-container">
        <mat-spinner></mat-spinner>
        <p>Loading tables...</p>
      </div>

      <!-- Tables list -->
      <div *ngIf="!loading" class="tables-list">
        <div *ngFor="let table of tables" class="table-item">
          <div class="table-info">
            <div class="table-header">
              <h3>{{ table.tableName }}</h3>
              <div class="table-badges">
                <span *ngIf="table.isDefault" class="badge default">Default</span>
                <span *ngIf="table.isShared" class="badge shared">Shared</span>
              </div>
            </div>
            <p>{{ table.tableDescription || 'No description available' }}</p>
            <div *ngIf="table.isShared && table.sharedTo?.length > 0" class="shared-users">
              <span class="shared-label">Shared with:</span>
              <span class="shared-emails">{{ table.sharedTo.join(', ') }}</span>
            </div>
            <div class="table-meta">
              <span class="meta-item">
                <mat-icon>schedule</mat-icon>
                Modified: {{ table.modifiedDate | date:'short' }}
              </span>
              <span class="meta-item">
                <mat-icon>person</mat-icon>
                {{ table.modifiedBy }}
              </span>
              <span class="meta-item">
                <mat-icon>view_column</mat-icon>
                {{ table.columnList.length }} columns
              </span>
            </div>
          </div>
          <div class="table-actions">
            <button mat-raised-button color="accent" (click)="onEditTable(table)">
              <mat-icon>edit</mat-icon>
              Edit
            </button>
            <button mat-raised-button color="warn" (click)="onDeleteTable(table)">
              <mat-icon>delete</mat-icon>
              Delete
            </button>
          </div>
        </div>
      </div>

      <!-- Empty state -->
      <div *ngIf="!loading && tables.length === 0" class="no-tables">
        <mat-icon class="empty-icon">table_chart</mat-icon>
        <p>No tables found. Create your first table to get started.</p>
        <button mat-raised-button color="primary" (click)="onCreateTable()">
          <mat-icon>add</mat-icon>
          Create Table
        </button>
      </div>
    </div>
  </div>

  <!-- Table Editor View -->
  <div *ngIf="showTableEditor" class="table-editor-view">
    <bhub-table-editor
      [table]="editingTable"
      (save)="onTableEditorSave($event)"
      (cancel)="onTableEditorCancel()"
    ></bhub-table-editor>
  </div>
</div>
